"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tailwind_1 = require("../utilities/tailwind.js");
function LayoutComponent({ children }) {
    // Mobile (< sm) is a grid: Content stretches to fill the viewport, so BottomNavigation sits at the screen's bottom
    // edge on short pages. sm and up switch to a plain column flow: Content sizes to its own content and
    // BottomNavigation follows it. On every breakpoint BottomNavigation sticks to the viewport bottom once the page is
    // taller than the screen.
    return (0, jsx_runtime_1.jsx)("div", { className: "koa:min-h-dvh koa:grid koa:grid-rows-[auto_1fr_auto] koa:sm:flex koa:sm:flex-col", children: children });
}
LayoutComponent.displayName = "Layout";
function Header({ children, fixed }) {
    return (0, jsx_runtime_1.jsx)("div", { className: ` ${fixed ? "koa:fixed koa:left-0 koa:w-full" : "koa:sticky"} koa:top-0 koa:z-50`, children: children });
}
Header.displayName = "Layout.Header";
function Content({ children, fullWidth, fill }) {
    return ((0, jsx_runtime_1.jsx)("main", { className: `${fullWidth ? "koa:w-full" : "koa:max-w-xl koa:w-full"} ${fill ? "koa:flex koa:flex-col koa:sm:flex-1" : ""} koa:mx-auto koa:px-gutter koa:py-2 koa:sm:py-4`, children: children }));
}
Content.displayName = "Layout.Content";
function BottomNavigation({ children, className }) {
    // Sticky in the document flow at every breakpoint now, never docked with `fixed`: iOS Safari clips
    // fixed-positioned content above its bottom glass bar, so the nav has to be real content the page can
    // scroll to, not an overlay. Short pages keep it right under the content; long ones let it stick to the
    // viewport bottom (with a small gap so it clears the glass bar) while the rest scrolls underneath.
    return (0, jsx_runtime_1.jsx)("div", { className: (0, tailwind_1.twMerge)("koa:sticky koa:bottom-4 koa:z-20", className), children: children });
}
BottomNavigation.displayName = "Layout.BottomNavigation";
function Footer({ children }) {
    if (!children) {
        return null;
    }
    // In the document flow as the layout's last child, never `fixed`: embeds are usually shorter than the page
    // (partners use a 600px iframe), and an overlay docked to the frame's bottom covered cards and buttons there.
    // `mt-auto` pushes it to the bottom of short pages (in the mobile grid's last row and the sm+ column alike);
    // on long pages it follows the content, and a sticky BottomNavigation stops right above it.
    return (0, jsx_runtime_1.jsx)("footer", { className: "koa:grid koa:justify-items-center koa:mt-auto koa:p-1 koa:pt-2 koa:sm:pt-3 koa:lg:pt-4", children: children });
}
Footer.displayName = "Layout.Footer";
exports.Layout = Object.assign(LayoutComponent, {
    Header,
    Content,
    BottomNavigation,
    Footer,
});
